import { RouteObject } from 'react-router-dom'
import PageLayout from '../../../common/app/page/PageLayout'
import PageLoadingSupport from '../../../common/app/PageLoadingSupport'
import { default as Workforce } from '.'

const basePath = '/time/workforce'
export const workforceRoutes: RouteObject[] = [
  {
    path: `${basePath}/staff-members`,
    element: (
      <PageLayout title={'Manage Staff Members'} displayLeftTitle={false}>
        <Workforce.StaffMembers.Component />
      </PageLayout>
    ),
    loader: Workforce.StaffMembers.Loader,
  },
  {
    path: `${basePath}/staff-members/:staffMemberId`,
    element: (
      <PageLayout>
        <Workforce.EditStaffMember.Component />
      </PageLayout>
    ),
    loader: Workforce.EditStaffMember.Loader,
  },
  {
    path: `${basePath}/staff-members/add`,
    element: (
      <PageLayout title={'New Staff Member'} displayLeftTitle={false}>
        <Workforce.AddStaffMember.Component />
      </PageLayout>
    ),
    loader: Workforce.AddStaffMember.Loader,
  },
  {
    path: '/employee/request-information',
    element: (
      <PageLoadingSupport title="Request Employee Information">
        <Workforce.RequestEmployeeInformation.Component />
      </PageLoadingSupport>
    ),
    loader: Workforce.RequestEmployeeInformation.Loader,
  },
  {
    path: '/employee/unavailability/status',
    element: (
      <PageLoadingSupport title="Unavailability Status">
        <Workforce.UnavailabilityStatus.Component />
      </PageLoadingSupport>
    ),
    loader: Workforce.UnavailabilityStatus.Loader,
  },
  {
    path: '/employee/leave/status',
    element: (
      <PageLoadingSupport title="Leave Status">
        <Workforce.LeaveRequestStatus.Component />
      </PageLoadingSupport>
    ),
    loader: Workforce.LeaveRequestStatus.Loader,
  },
  {
    path: '/employee/shift-request/status',
    element: (
      <PageLoadingSupport title="Shift Request Status">
        <Workforce.ShiftRequestStatus.Component />
      </PageLoadingSupport>
    ),
    loader: Workforce.ShiftRequestStatus.Loader,
  },
  {
    path: `${basePath}/approvals`,
    element: (
      <PageLayout title={'Approvals'} displayLeftTitle={false}>
        <Workforce.Approvals.Component />
      </PageLayout>
    ),
    loader: Workforce.Approvals.Loader,
  },
  {
    path: `${basePath}/approvals/:type/:requestId`,
    element: (
      <PageLayout title={'Approvals'} displayLeftTitle={false}>
        <Workforce.ManageRequest.Component />
      </PageLayout>
    ),
    loader: Workforce.ManageRequest.Loader,
  },
  {
    path: `${basePath}/documents`,
    element: (
      <PageLayout title={'Document Templates'} displayLeftTitle={false}>
        <Workforce.Documents.Component />
      </PageLayout>
    ),
    loader: Workforce.Documents.Loader,
  },
  {
    path: `${basePath}/onboarding-packs`,
    element: (
      <PageLayout title={'Onboarding Packs'} displayLeftTitle={false}>
        <Workforce.OnboardingPacks.Component />
      </PageLayout>
    ),
    loader: Workforce.OnboardingPacks.Loader,
  },
]
